/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import React from 'react';
import { initReactI18next, useTranslation as useTranslation$1 } from 'react-i18next';
import i18n from '@console/i18n';
export { default, default as i18n } from '@console/i18n';
import resourcesToBackend from 'i18next-resources-to-backend';
import locales from '../../locales/index.js';

i18n.use(resourcesToBackend(locales)).use(initReactI18next).init({
  interpolation: {
    escapeValue: false
  },
  react: {
    useSuspense: false
  },
  keySeparator: false,
  nsSeparator: false,
  defaultNS: 'translations',
  supportedLngs: ['en', 'es', 'de', 'fr', 'it', 'ja', 'ko', 'pt-BR', 'zh-CN', 'zh-TW']
});

// Ignoring because this only gets changed based on what environment
// eslint-disable-next-line import/no-mutable-exports
var useTranslation = function useTranslation() {
  var _document;
  var i18nInstance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : i18n;
  var _reactI18nUseTranslat = useTranslation$1('translations', {
      i18n: i18nInstance
    }),
    t = _reactI18nUseTranslat.t,
    ready = _reactI18nUseTranslat.ready;
  var lang = typeof document !== 'undefined' && ((_document = document) === null || _document === void 0 || (_document = _document.documentElement) === null || _document === void 0 ? void 0 : _document.lang);
  React.useEffect(function () {
    var _process;
    if (typeof process !== 'undefined' && (_process = process) !== null && _process !== void 0 && (_process = _process.env) !== null && _process !== void 0 && _process.STORYBOOK && lang) i18n.changeLanguage(lang);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang]);
  return {
    t: ready ? t : (i18n === null || i18n === void 0 ? void 0 : i18n.t) || function () {
      return '';
    },
    ready: ready
  };
};

export { useTranslation };
